'use strict';

angular.module('app')
  .directive('showLoginPopup', function($uibModal) {
    return {
      restrict: 'A',
      
      scope: {
        callback: '&callback'
      },
      link: function(scope, element, attr) {
        element.on('click', function() {
            var modalInstance = $uibModal.open({
				animation: true,
				templateUrl: '../templates/_login-popup.html',
				controller: function(Auth, $rootScope, $uibModalInstance) {
					var vm = this;
                    
                    vm.socialLogin = function() {
                        return Auth.socialLogin(function(user) {
                            $rootScope.user = Auth.getUser();
                            console.log(user)

                            if (user.status === 'terms_not_accepted') {
                                Auth.showTermsModal(scope.callback)
                            } 
                            
                            $uibModalInstance.close()
                        }, undefined, true);
                    }

                    vm.login = function(loginForm) {
                        loginForm.$setSubmitted()

                        if (loginForm.$invalid) { return false }

                        return Auth.login(vm.form, true).then(function() {
                            $rootScope.user = Auth.getUser();

						    $uibModalInstance.close(1);
                        }).catch(function(data){
                            vm.regErrors = data;
                        });
                    }
				},
				controllerAs: 'loginCtrl',
				keyboard: true,
				scope: scope
			});

			return modalInstance.result.then(function(res) {
                if (scope.callback) { scope.callback() }
			}, function(err) {
			})
        })
      }
    };
  });